import { appBaseUrl } from "utils/config";
import { postService } from "../../../commonServices";

export class QuickMessageService {
  composeQuickMessage(body) {
    let url = `${appBaseUrl}/mailMessageCenter/composeQuickMessage`;
    let data = postService(url, body, 'post');
    return data;
  }
}